<div class="container my-3">
    <!-- <h1 class="mb-4">Add Operation Data</h1> -->
    <form #form="ngForm" (ngSubmit)="addRawOpData()" class="mt-2">
        <div>
            <!-- Commented on 20th april 2026 for the breadcrumb changes -->
            <!-- <div class="row mb-3">
                <div class="col-sm-3" style="text-align: right">
                    <label for="PlantId" class="form-label">Plant :</label>
                </div>
                <div class="col-sm-4">
                    <select
          class="form-select border border-dark"
          name="plantid"
          (change)="getSelectedPlantId($event)">
          <option selected>Select Plant</option>
          <option *ngFor="let plant of plants" [value]="plant.Id">
            {{ plant.Name }}
          </option>
                    </select>
                  </div>
            </div> -->

            <!-- <div class="row mb-3">
                <div class="col-sm-3" style="text-align: right">
                  <label for="train" class="form-label">Train:</label>
                </div>
                <div class="col-sm-4">
                  <select
                    class="form-select border border-dark"
                    name="trainid"
                    (change)="getSelectedTrainDetails($event)"
                    [(ngModel)]="opdataModel.TrainId"
                  >
               
                    <option *ngFor="let train of trains" [value]="train.Id">
                      {{ train.Name }}
                    </option>
                  </select>
                </div>
              </div> -->
          
              <div class="row mb-3">
                <div class="col-sm-3" style="text-align: right">
                  <label for="Datetime" class="form-label">Datetime</label>
                </div>
                <div class="col-sm-4">
                  <input
                    type="datetime-local"
                    pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}"
                    class="form-control border border-dark"
                    id="Datetime"
                    name="Datetime"
                    [(ngModel)]="opdataModel.Datetime"
                  />
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-3" style="text-align: right">
                  <label for="train" class="form-label">Feed pH:</label>
                </div>
                <div class="col-sm-4">
                    <input
                    type="number"
                    class="form-control border border-dark"
                    id="feedpH"
                    name="feedpH"
                    [(ngModel)]="opdataModel.Ph" />
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-sm-3" style="text-align: right">
                  <label for="train" class="form-label">Feed Temperature (°C):</label>
                </div>
                <div class="col-sm-4">
                    <input
                    type="number"
                    class="form-control border border-dark"
                    id="feedTemp"
                    name="feedTemp"
                    [(ngModel)]="opdataModel.Temp" />
                </div>
              </div>
             

          <div>
            <div class="row">
              <div class="col-sm-3" style="text-align: right">
                <label
                  for="ChemicalUsed"
                  class="form-label"
                  style="font-weight: bold; display: inline-block"
                  >Stage 1:
                </label>
              </div>                
            </div>

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Concentrate Flow:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s1ConcFlow"
                  name="s1ConcFlow"
                  [(ngModel)]="opdataModel.S1ConcFlow" />
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Flow:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s1PermFlow"
                  name="s1PermFlow"
                  [(ngModel)]="opdataModel.S1PermFlow" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Feed Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s1FeedPress"
                  name="s1FeedPress"
                  [(ngModel)]="opdataModel.S1FeedPress" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Concentrate Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s1ConcPress"
                  name="s1ConcPress"
                  [(ngModel)]="opdataModel.S1ConcPress" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s1PermPress"
                  name="s1PermPress"
                  [(ngModel)]="opdataModel.S1PermPress" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Feed Conductivity:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s1FeedCond"
                  name="s1FeedCond"
                  [(ngModel)]="opdataModel.S1FeedCond" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Conductivity:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s1PermCond"
                  name="s1PermCond"
                  [(ngModel)]="opdataModel.S1PermCond" />
              </div>
            </div>
        </div>

        <div [hidden]="this.noOfStages < 2">
            <div class="row">
              <div class="col-sm-3" style="text-align: right">
                <label
                  for="ChemicalUsed"
                  class="form-label"
                  style="font-weight: bold; display: inline-block"
                  >Stage 2:
                </label>
              </div>                
            </div>

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Concentrate Flow:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s2ConcFlow"
                  name="s2ConcFlow"
                  [(ngModel)]="opdataModel.S2concflow" />
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Flow:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s2PermFlow"
                  name="s2PermFlow"
                  [(ngModel)]="opdataModel.S2permflow" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Feed Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s2FeedPress"
                  name="s2FeedPress"
                  [(ngModel)]="opdataModel.S2feedpress" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Concentrate Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s2ConcPress"
                  name="s2ConcPress"
                  [(ngModel)]="opdataModel.S2concpress" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s2PermPress"
                  name="s2PermPress"
                  [(ngModel)]="opdataModel.S2permpress" />
              </div>
            </div>
        

            

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Conductivity:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s2PermCond"
                  name="s2PermCond"
                  [(ngModel)]="opdataModel.S2permcond" />
              </div>
            </div>
        </div>

        <div [hidden]="this.noOfStages < 3">
            <div class="row">
              <div class="col-sm-3" style="text-align: right">
                <label
                  for="ChemicalUsed"
                  class="form-label"
                  style="font-weight: bold; display: inline-block"
                  >Stage 3:
                </label>
              </div>                
            </div>

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Concentrate Flow:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s3ConcFlow"
                  name="s3ConcFlow"
                  [(ngModel)]="opdataModel.S3concflow" />
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Flow:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s3PermFlow"
                  name="s3PermFlow"
                  [(ngModel)]="opdataModel.S3permflow" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Feed Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s3FeedPress"
                  name="s3FeedPress"
                  [(ngModel)]="opdataModel.S3feedpress" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Concentrate Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s3ConcPress"
                  name="s3ConcPress"
                  [(ngModel)]="opdataModel.S3concpress" />
              </div>
            </div>
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Pressure:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s3PermPress"
                  name="s3PermPress"
                  [(ngModel)]="opdataModel.S3permpress" />
              </div>
            </div>
        

       
        

            <div class="row mb-3">
              <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">Permeate Conductivity:</label>
              </div>
              <div class="col-sm-4">
                  <input
                  type="number"
                  class="form-control border border-dark"
                  id="s3PermCond"
                  name="s3PermCond"
                  [(ngModel)]="opdataModel.S3permcond" />
              </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3" style="text-align: right">
                <label for="train" class="form-label">&nbsp;</label>
              </div>
        </div>
        <div *ngIf="showUserDefinedDiv">
          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: right" *ngIf="showUserDefinedField1">
              <label for="train" class="form-label">User Defined 1:</label>
            </div>
            <div class="col-sm-4">
                <input
                type="number"
                *ngIf="showUserDefinedField1"
                class="form-control border border-dark"
                id="UD1"
                name="UD1"
                [(ngModel)]="opdataModel.Ud1" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: right" *ngIf="showUserDefinedField2">
              <label for="train" class="form-label">User Defined 2:</label>
            </div>
            <div class="col-sm-4">
                <input
                type="number"
                class="form-control border border-dark"
                *ngIf="showUserDefinedField2"
                id="UD2"
                name="UD2"
                [(ngModel)]="opdataModel.Ud2" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: right" *ngIf="showUserDefinedField3">
              <label for="train" class="form-label">User Defined 3:</label>
            </div>
            <div class="col-sm-4">
                <input
                type="number"
                class="form-control border border-dark"
                *ngIf="showUserDefinedField3"
                id="UD3"
                name="UD3"
                [(ngModel)]="opdataModel.Ud3" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: right" *ngIf="showUserDefinedField4">
              <label for="train" class="form-label">User Defined 4:</label>
            </div>
            <div class="col-sm-4">
                <input
                type="number"
                class="form-control border border-dark"
                *ngIf="showUserDefinedField4"
                id="UD4"
                name="UD4"
                [(ngModel)]="opdataModel.Ud4" />
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: right" *ngIf="showUserDefinedField5">
              <label for="train" class="form-label">User Defined 5:</label>
            </div>
            <div class="col-sm-4">
                <input
                type="number"
                class="form-control border border-dark"
                *ngIf="showUserDefinedField5"
                id="UD5"
                name="UD5"
                [(ngModel)]="opdataModel.Ud5" />
            </div>
          </div>
        </div>


          <div class="row mb-3">
            <div class="col-sm-3" style="text-align: right">
              <label for="train" class="form-label">Comments:</label>
            </div>
            <div class="col-sm-4">
            
            <input
          type="text"
          class="form-control border border-dark"
          id="Comments"
          name="Comments"
          [(ngModel)]="opdataModel.Comments"
          
          />
            </div>
          </div>
          

        </div>

        <div class="row">
            <div class="col-sm-6" style="text-align: right">
              <button type="submit" class="btn custom-buttons-btn mt-3">Create</button>
             
            </div>
            <div class="col-sm-2" style="text-align: left">
              <button type="button" class="btn custom-buttons-btn mt-3">Reset</button>
            </div>
          </div>
    </form>
</div>
